import { makeObservable, observable, action } from 'mobx';
import { RootStore } from './Root.store';

export enum windows {
    authentication = 'authentication',
    register = 'register',
    passwordRecovery = 'passwordRecovery',
}

export type window = `${windows}`;

export default class ModalStore {
    @observable
    public window: window | null;

    constructor(private rootStore: RootStore) {
        this.setDefault();
        makeObservable(this);
    }

    @action
    setDefault() {
        this.window = null;
    }

    @action
    openAuthentication() {
        this.window = windows.authentication;
    }

    @action
    openRegister() {
        this.window = windows.register;
    }

    @action
    openPasswordRecovery() {
        this.window = windows.passwordRecovery;
    }

    @action
    closeModal() {
        this.window = null;
    }
}
